module.exports = __webpack_public_path__ + "img/cho3.ac76bab5.png";